import translate from "../../../translations/translations.wrapper.jsx";
import { formatDateTime } from "utils/valueFormatter.function";
import { NewCommentsListProps, Comment } from "types/comments";
import React from "react";
import NewCommentsProfile from "components/taskdetails-remake/panels/comments/NewCommentsProfile.component";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import * as reduxSelectors from "components/store/application.reducers";
import { launchDarkly } from "utils/launchDarkly";

export const NewCommentsList: React.FC<NewCommentsListProps> = (props) => {

    const isLoading = useSelector(reduxSelectors.getTaskCommentsLoadingStatus);
    const commentsAndEvents: Array<Comment> = useSelector(reduxSelectors.getTaskCommentsAndEvents);
    const comments: Array<Comment> = useSelector(reduxSelectors.getTaskComments);
    const showCommentsAndEvents = launchDarkly.companyClient && launchDarkly.companyClient.variation("FE-show-comments-and-events", false);

    const displayedComments: Array<Comment> = showCommentsAndEvents ? commentsAndEvents : comments;
    const mapComment = function(comment: Comment, index: number) {
        const actionDescription = [1, 2, 3, 5, 9, 22, 55];
        return (
            <div className="comments-list-item" key={`${comment.nodeId}-${index}`}>
                <NewCommentsProfile connectUserId={comment.connectUserId}
                                    userName={comment.userName}
                                    externalApplicationName={comment.externalApplicationName}
                                    eventType={comment.eventType}>

                </NewCommentsProfile>
                <div className="comments-list-item-body">
                    <div className="comments-list-item-heading">
                            <span className="comments-list-item-user">
                                {comment.userName}
                            </span>
                        <span className="comments-list-item-date">
                                {formatDateTime(comment.createdDate, "")}
                            </span>
                    </div>
                    {actionDescription.includes(comment.eventType) &&
                        <div className="comments-list-action">
                            {props.translate(`taskDetail.commentsAction.${comment.eventType}`)}
                        </div>}
                    <div className="comments-list-item-comment">
                        {comment.content}
                    </div>
                </div>
            </div>
        );

    };


    const commentsList = [
        ...displayedComments,
    ].map((comment, index) => {
        return mapComment(comment, index);
    });

    const renderLoading = function() {
        return <div className="grid-comments-panel-loading">
            <div className="comment-loading-skeleton">
                <Skeleton className="comment-image-loading-skeleton" />
                <Skeleton className="comment-content-loading-skeleton" />
            </div>
            <div className="comment-loading-skeleton">
                <Skeleton className="comment-image-loading-skeleton" />
                <Skeleton className="comment-content-loading-skeleton" />
            </div>
            <div className="comment-loading-skeleton">
                <Skeleton className="comment-image-loading-skeleton" />
                <Skeleton className="comment-content-loading-skeleton" />
            </div>
        </div>;
    };

    return (
        <div className="comments-list">
            {isLoading ? renderLoading() : commentsList}
        </div>

    );
};

const withTranslations = translate(NewCommentsList);
export default withTranslations;
